import type { LabelInValue } from 'models';
import { useCallback } from 'react';
import type { TelehealthRequestVisitData } from '../../../../queries';
import type { TelehealthRequestFormValues } from '../TelehealthRequestContent';

type P = {
  data: { medicalGroup: LabelInValue } & Omit<TelehealthRequestFormValues, 'medicalGroup'>;
};

export const useCreateTelehealtVisitData = () =>
  useCallback(
    ({ data }: P): TelehealthRequestVisitData => ({
      medicalGroup: data.medicalGroup,
      reason: data.textContent,
      visitType: { name: data.visitType.value, translations: data.visitType.translations },
      visitTypeSubOption: data.visitTypeSubOption
        ? {
            name: data.visitTypeSubOption.value,
            translations: data.visitTypeSubOption.translations,
          }
        : undefined,
      visitTypeSubSubOption: data.visitTypeSubSubOption
        ? {
            name: data.visitTypeSubSubOption.value,
            translations: data.visitTypeSubSubOption.translations,
          }
        : undefined,
    }),
    [],
  );
